module.exports = __webpack_public_path__ + "static/fashion-0624623bb250f814ccf651b25066a8f8.svg";